import { render, staticRenderFns } from "./DialogShipmentGhn.pug?vue&type=template&id=58d99e72&scoped=true&lang=pug&"
import script from "./DialogShipmentGhn.vue?vue&type=script&lang=js&"
export * from "./DialogShipmentGhn.vue?vue&type=script&lang=js&"
import style0 from "./DialogShipmentGhn.scss?vue&type=style&index=0&id=58d99e72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d99e72",
  null
  
)

export default component.exports